import React from 'react';
import styled, {css} from 'styled-components';
import {defaultTheme} from '../../data/themes';
import Icon from '../icon';

function getStyle(props, name, type) {
	let theme = props.theme;
	const fullName = 'full' + name;
	name = type + name;
	return theme[name] || defaultTheme[name] || theme[fullName] || defaultTheme[fullName];
}

const ButtonWrapper = styled.div`
	display: ${props => props.block ? 'table': 'inline-table'};
	outline: none;
	white-space: nowrap;
	border: ${props => getStyle(props, 'ButtonBorder', props.type)};
	cursor: ${props => getStyle(props, 'ButtonCursor', props.type)};
	font-weight: ${props => getStyle(props, 'ButtonFontWeight', props.type)};
	font-size: ${props => getStyle(props, 'ButtonFontSize', props.type)};
	background: ${props => getStyle(props, 'ButtonBackground', props.type)};
	color: ${props => getStyle(props, 'ButtonColor', props.type)};
	padding: ${props => props.padding || getStyle(props, 'ButtonPadding', props.type)};
	margin: ${props => props.margin || getStyle(props, 'ButtonMargin', props.type)};
	width: ${props => props.width};
	min-width: ${props => props.minWidth};
	border-radius: ${props => props.padding || getStyle(props, 'ButtonBorderRadius', props.type)};
	box-shadow: ${props => props.padding || getStyle(props, 'ButtonShadow', props.type)};
	&:not(.disabled):hover {
		box-shadow: ${props => props.padding || getStyle(props, 'ButtonHoverShadow', props.type)};
		border: ${props => getStyle(props, 'ButtonHoverBorder', props.type)};
		text-decoration: ${props => getStyle(props, 'ButtonHoverTextDecoration', props.type)};
		background: ${props => getStyle(props, 'ButtonHoverBackground', props.type)};
		color: ${props => getStyle(props, 'ButtonHoverColor', props.type)};
		padding: ${props => props.padding || getStyle(props, 'ButtonHoverPadding', props.type)};
	}
	&.negative {
		border: ${props => getStyle(props, 'NegativeButtonBorder', props.type)};
		background: ${props => getStyle(props, 'NegativeButtonBackground', props.type)};
		color: ${props => getStyle(props, 'NegativeButtonColor', props.type)};
		&:not(.disabled):hover {
			border: ${props => getStyle(props, 'NegativeButtonHoverBorder', props.type)};
			background: ${props => getStyle(props, 'NegativeButtonHoverBackground', props.type)};
			color: ${props => getStyle(props, 'NegativeButtonHoverColor', props.type)};
		}
	}
	&.disabled {
		opacity: 0.3;
		cursor: default;
	}

	.icon {
		position: relative;

		&.left {
			top: -2px;
			margin-right: 4px;
		}

		&.right {
			top: -1px;
			margin-left: 4px;
		}

	}

	[type=light] {
	}

	[type=medium] {
		.icon {
			font-size: 110%;
		}
	}


	> .text {
		display: table-cell;
		vertical-align: middle;
		text-align: center;
	}
`;

export default class Button extends React.PureComponent {

	constructor() {
		super();
		this.onMouseDown = this.onMouseDown.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	onAction(e) {
		if (this.props.disabled) {
			return;
		}
		if (typeof this.props.onAction === 'function') {
			this.props.onAction();
		}

	}

	onKeyDown(e) {
		const keyCode = e.keyCode;
		if ((keyCode === 13) || (keyCode === 32)) {
			this.onAction(e);
		}
	}

	onMouseDown(e) {
		e.preventDefault();
		e.target.closest('.ps-button').focus();
		window.setTimeout(() => {
			this.onAction(e);
		}, 0);

	}

	render() {
		let type = this.props.type || 'full';
		return (
			<ButtonWrapper
				tabIndex="-1"
				className={'ps-button' + (this.props.negative ? ' negative' : '') + (this.props.disabled ? ' disabled' : '') + (this.props.className ? (' ' + this.props.className) : '')}
				onMouseDown={this.onMouseDown}
				onKeyDown={this.onKeyDown}
				type={type}
				block={this.props.block}
				padding={this.props.padding}
				margin={this.props.margin}
				width={this.props.width}
				minWidth={this.props.minWidth}
				data-name={this.props.name}
				ref={this.props.externalRef}
			>
				{
					this.props.iconName && (
						<Icon
							name={this.props.iconName}
							className="left"
						/>
					)
				}
				<span className="text">{this.props.text}</span>
				{
					this.props.rightIconName && (
						<Icon
							name={this.props.rightIconName}
							className="right"
						/>
					)
				}
			</ButtonWrapper>
		);
	}
}

